import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LumenOutputRangeService } from '../lumen-output-range.service';
import { Observable } from 'rxjs/Observable';
import { LumenOutputRange } from '../LumenOutputRange.model';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: './lumen-output-range-list.component.html'
})
export class LumenOutputRangeListComponent implements OnInit {

  displayedColumns = ['id', 'name', 'strip', 'actions'];
  dataSource: LumenOutputRangesDatasource | null;
  database: LumenOutputRangeDatabase;
  modalRef: BsModalRef;
  lumenOutputRangeId: number;
  typeFilterActive = false;

  @ViewChild('filter',{static: true}) public filter: ElementRef;
  @ViewChild(MatSort,{static: true}) public sort: MatSort;
  @ViewChild(MatPaginator,{static: true}) public paginator: MatPaginator;

  constructor(private router: Router,
    private lumenOutputRangeService: LumenOutputRangeService) {
  }

  ngOnInit(): void {
    this.database = new LumenOutputRangeDatabase(this.lumenOutputRangeService);
    this.dataSource = new LumenOutputRangesDatasource(this.database, this.paginator, this.sort)

    Observable.fromEvent(this.filter.nativeElement, 'keyup')
      .debounceTime(150)
      .distinctUntilChanged()
      .subscribe(() => {
        if (!this.dataSource) { return; }
        this.dataSource.filter = this.filter.nativeElement.value;
      });
  }


  redirectToEdit(lumenOutputRangeId) {
    this.router.navigate(['./lumen-output-range/edit/' + lumenOutputRangeId]);
  }


  onTypeChange(typeId) {
    const test = Number(typeId);
    console.log(test);
    this.dataSource.typeFilter = test;
    this.typeFilterActive = this.dataSource.typeFilter !== -1;
  }
}

export class LumenOutputRangeDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<LumenOutputRange[]> = new BehaviorSubject<LumenOutputRange[]>([]);
  get data(): LumenOutputRange[] { return this.dataChange.value; }

  constructor(lumenOutputRangeService: LumenOutputRangeService) {
    lumenOutputRangeService.getLumenOutputRange().subscribe(
      lumenOutputRange => {
        this.dataChange.next(lumenOutputRange);
      });
  }
}


export class LumenOutputRangesDatasource extends DataSource<LumenOutputRange> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }
  _typeFilterChange = new BehaviorSubject(-1);

  get typeFilter(): number {
    return this._typeFilterChange.value;
  }

  set typeFilter(typeId: number) {
    this._typeFilterChange.next(typeId);
  }
  prevFilterValue: string;

  constructor(private _database: LumenOutputRangeDatabase, private _paginator: MatPaginator, private _sort: MatSort) {
    super();
    this.prevFilterValue = this.filter.toLowerCase();
  }

  connect(collectionViewer: CollectionViewer): Observable<LumenOutputRange[]> {
    const displayDataChanges = [
      this._database.dataChange,
      this._filterChange,
      this._sort.sortChange,
      this._typeFilterChange,
      this._paginator.page
    ];
    return Observable.merge(...displayDataChanges).map(() => {

      const data = this._database.data.slice().filter((item: LumenOutputRange) => {
        if (item.name == null) {
          return false;
        }
        const searchStr = (item.name).toLowerCase();
        const searchResult = searchStr.indexOf(this.filter.toLowerCase()) !== -1;
        return searchResult;
      });

      if (this.filter.toLowerCase() !== this.prevFilterValue) {
        this._paginator.pageIndex = 0;
      }
      this.prevFilterValue = this.filter.toLowerCase();

      // Sort filtered data
      const sortedData = this.sortData(data.slice());

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return sortedData.splice(startIndex, this._paginator.pageSize);
    });
  }

  disconnect(collectionViewer: CollectionViewer): void {
  }
  /** Returns a sorted copy of the database data. */
  sortData(data: LumenOutputRange[]): LumenOutputRange[] {
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'id': [propertyA, propertyB] = [a.id, b.id]; break;
        case 'name': [propertyA, propertyB] = [a.name, b.name]; break;
        case 'city': [propertyA, propertyB] = [a.name, b.name]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}
